module.exports = __webpack_public_path__ + "images/49f91c44c6330e23b6282954090857f6.png";